import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Modal, Tabs } from 'antd'
import WrappedDocProfile from '../DocumentProfile'


const DocumnetForm = (props) => {
  const { visible, onOk, onCancel, formData } = props

  return (
    <Modal
      width={1000}
      destroyOnClose={true}
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} Document`}
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <Tabs type="card" defaultActiveKey="1">
        <Tabs.TabPane tab="Document" key="1">
          <WrappedDocProfile
            onOk={onOk}
            onCancel={onCancel}
            formData={formData}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}

DocumnetForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default DocumnetForm
